import { DecodedValueMap, QueryParamConfigMap } from 'common/hooks/customSearchParams';
import _ from 'lodash';
import { QueryClient } from '@tanstack/react-query';
import {
  updateWatchList,
  updateWatchListWithDeleted,
  WatchListFilters,
  WatchlistQueryKeys,
} from 'services/clients/watchList';
import { clearFilters } from '../filters/utils';

export const archiveContainers = async (
  searchedContainers: string[],
  containerNumbersToArchive: string[],
  transactionIdsToArchive: string[],
  watchListFilters: WatchListFilters | null,
  setSearchParams: (obj: Partial<DecodedValueMap<QueryParamConfigMap>>) => void,
  queryClient: QueryClient,
  shouldArchive = true
) => {
  let promise;
  if (transactionIdsToArchive.length > 0) {
    promise = updateWatchList({
      transactionIds: transactionIdsToArchive,
      updateDeleted: shouldArchive,
    });
  } else if (watchListFilters) {
    promise = updateWatchList({ view: watchListFilters, updateDeleted: shouldArchive });
  } else {
    throw Error('containerNumbersToArchive or watchListFilters need to be defined');
  }

  if (
    searchedContainers.length > 0 &&
    containerNumbersToArchive.some((c: string) => searchedContainers.includes(c))
  ) {
    setSearchParams({
      containerNumbers: _.without(searchedContainers, ...containerNumbersToArchive),
    });
  }

  if (containerNumbersToArchive.length === 0) {
    setSearchParams({
      ...clearFilters(),
      page: 1,
    });
  }

  return promise.then((r) => {
    queryClient.invalidateQueries(['watchList']);
    queryClient.invalidateQueries(['watchListCount']);
    return r;
  });
};

export const deleteContainers = async (
  searchedContainers: string[],
  containerNumbersToArchive: string[],
  transactionIdsToArchive: string[],
  watchListFilters: WatchListFilters | null,
  setSearchParams: (obj: Partial<DecodedValueMap<QueryParamConfigMap>>) => void,
  queryClient: QueryClient,
  shouldDelete = true
) => {
  let promise;
  if (transactionIdsToArchive.length > 0) {
    promise = updateWatchListWithDeleted({
      transactionIds: transactionIdsToArchive,
      updateDeleted: shouldDelete,
    });
  } else if (watchListFilters) {
    promise = updateWatchListWithDeleted({ view: watchListFilters, updateDeleted: shouldDelete });
  } else {
    throw Error('containerNumbersToArchive or watchListFilters need to be defined');
  }

  if (
    searchedContainers.length > 0 &&
    containerNumbersToArchive.some((c: string) => searchedContainers.includes(c))
  ) {
    setSearchParams({
      containerNumbers: _.without(searchedContainers, ...containerNumbersToArchive),
    });
  }

  if (containerNumbersToArchive.length === 0) {
    setSearchParams({
      ...clearFilters(),
      page: 1,
    });
  }

  return promise.then((r) => {
    queryClient.invalidateQueries(['watchList']);
    queryClient.invalidateQueries(['watchListCount']);
    queryClient.invalidateQueries([WatchlistQueryKeys.Watchlist]);
    return r;
  });
};
